import { BackLink } from '@/components/BackLink';
import { LoginCta } from '@/components/LoginCta';
import { Menu } from '@/components/Menu';
import { Section } from '@/components/Section';
import { useModal } from '@/hooks/useModal';
import { AdSearchType, useAccount } from '@/resource/account';
import { PrivateProfileItemType } from '@/resource/profile';
import { useSettings } from '@/resource/settings';
import { SerializableObject } from '@/util/types';
import { FC } from 'react';
import { useQueryClient } from 'react-query';
import styles from './Layout.module.scss';
import { AccountSectionType, getAccountSections } from './getAccountSections';

export function withAccountLayout<T extends SerializableObject>(
  Inner: FC<
    T & {
      profile: PrivateProfileItemType;
      sections: AccountSectionType[];
      adSearches: AdSearchType[];
    }
  >
) {
  function Outer(props: T) {
    const modal = useModal();
    const settings = useSettings();
    const queryClient = useQueryClient();
    const account = useAccount();
    const { profile } = account;

    if (!profile) {
      return (
        <Section>
          <LoginCta title="Log in om je account te bekijken" />
        </Section>
      );
    }

    const sections = getAccountSections(queryClient, settings, account, modal);
    return (
      <>
        <BackLink to={{ type: 'account' }} title="Overzicht" hidden="lg" />
        <Section>
          <div className={styles.Layout}>
            <Menu sections={sections} />

            <Inner
              {...props}
              profile={profile}
              adSearches={account.adSearches}
              sections={sections}
            />
          </div>
        </Section>
      </>
    );
  }

  return Outer;
}
